// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","351":"commons","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"193cef3f6f59d7d87095","351":"1fb9ca366adc2e25b0d4","532":"4279b6790bc4aeb941d9","691":"049856cc5ebf7fd2aed8"}[chunkId] + ".js";
};